<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202403_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202403_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-center"><span>効果的な対策は？</span><br>春のゆらぎ肌とスキンケア</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">ゆらぎ肌を感じやすい春<br>スキンケアも季節に合わせて<br>対策していますか？</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202403_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">なぜ春はゆらぎ肌になりやすい？</h3>
        <p class="mb-3">だんだんと暖かくなり、春らしい日が増えてきましたね。新生活が始まる方も多いでしょう。ウキウキする季節ですが、お肌にとってはスキンケアや対策が重要な時期だということは知っていますか？</p>
        <p class="mb-3">花粉や冬との寒暖差、新生活が始まることによる生活習慣の変化などさまざまな原因で、いつもとお肌の調子が違うと感じる人も多いことでしょう。</p>
        <p class="mb-3">そして、冬の紫外線に慣れたお肌は無防備になりやすく、知らずうちに春から強くなる紫外線から思わぬダメージを受けることも。</p>
        <p class="mb-3">この季節に感じる「いつもとなんとなく違うお肌の調子」。</p>
        <p>それこそ「春のゆらぎ肌」のサインかもしれません。</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5 mb-3">「ゆらぎ肌」ってなに？<br>みなさんの「ゆらぎ肌」と春のスキンケア意識を調査</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">今回は20代、30代、40代の一般女性を対象に</p>
      <p class="mb-3">「春のゆらぎ肌」に関する調査を実施。</p>
      <p>一般女性のみなさんに「春のゆらぎ肌」に対する意識と、ゆらぎ肌の対策について調査しました。</p>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">あなたはゆらぎ肌を経験したと感じたことはありますか？</h3>
        <p class="mb-3">まずは、20代、30代、40代の女性に、「春のゆらぎ肌」の意識について見ていきましょう。</p>
        <p class="mb-3"><strong>「ゆらぎ肌*を感じたことがありますか？」</strong></p>
        <p class="mb-3">半数以上の方が<strong>『ある（55.2％）』</strong>と回答。</p>
        <p>*ゆらぎ肌：肌のバリア機能が弱まることで、外的要因（花粉や埃、紫外線）、内的要因（ストレスや生活習慣の乱れ）の影響により肌の不調が起きている状態</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202403_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202403_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">ゆらぎ肌を感じやすいのは春</h3>
        <p class="mb-3"><strong>「ゆらぎ肌だと感じたタイミングはいつですか？（複数回答可）」</strong></p>
        <p class="mb-3"><strong>『3月（58.0％）』<br>『4月（47.0％）』</strong></p>
        <p class="mb-3">みなさんに、ゆらぎ肌だと感じたタイミングは春が多い結果に。</p>
        <p class="mb-3">気温の上昇とともに、紫外線も強まる季節。</p>
        <p class="mb-3">敏感肌の方はもちろん、普段お肌が荒れにくい方も、季節の変わり目である春はいつもよりも</p>
        <p class="mb-3">「なんだか肌の調子がよくない」</p>
        <p class="mb-3">と感じる方も多いはず。では、<strong>どんな対策が必要？</strong></p>
        <p class="mb-3">スキンケアにとって重要なことは、まず<strong>不調と感じる原因を知る</strong>こと。</p>
        <p>お悩みによって<strong>効果的な予防と対策を正しく行う</strong>ことです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">乾燥と花粉。言われてみれば、春ってお肌が無防備になりやすい？</h3>
        <p class="mb-3">では、実際にみなさんはどんな症状をゆらぎ肌として感じているのか聞いてみたところ<strong>『乾燥（76.0％）』</strong>と答えたが、なんと8割。</p>
        <p class="mb-3">多くの方が肌の乾燥を感じています。<strong>『春は気温や湿度の変化が大きく、肌のバリア機能に影響を与えやすい</strong>のです。</p>
        <p class="mb-3">そのため、いつもは感じない"かさつき"や"痒み"、"ひりつき"につながるのかもしれません。</p>
        <p class="mb-3">ではご自身のゆらぎ肌の原因として、<strong>「花粉」</strong>だと感じると答えた方が多いことも、春ならでは。</p>
        <p>新生活も始まり、<strong>『ストレス（23.4％）』</strong>や<strong>『生活習慣の乱れ（19.7％）』</strong>を感じる方も多いようです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202403_05.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202403_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">ゆらぎ肌対策。化粧品やスキンケアの見直す人は約3割。</h3>
        <p class="mb-3">「ゆらぎ肌の対策をしたことはありますか？」と質問したところ、<strong>約7割の方が『いいえ（69.8％）』</strong>と回答しました。</p>
        <p class="mb-3">続いて、「ゆらぎ肌の対策を行わなかった理由は何ですか？」について</p>
        <p class="mb-3"><strong>『何をすればいいかわからなかった（41.5％）』<br>『問題がないと感じた（36.7％）』</strong></p>
        <p class="mb-3">と答えた方が7割に。ゆらぎ肌の有効な対策方法がわからず、ゆらぎ肌をそのままにしてしまっている方が多いようです。</p>
        <p class="mb-3">では、<strong>ゆらぎ肌の対策</strong>をしたことがある方は、どのような対策をしていたのでしょうか。</p>
        <p class="mb-3"><strong>『化粧品の追加・変更（33.2％）』<br>『セルフスキンケア方法の見直し（30.9％）』<br>『生活習慣の改善（15.8％）』</strong></p>
        <p>約3割が化粧品を追加・変更したり、スキンケア方法を見直ししていることが明らかに。</p>
      </div>
    </div>

    <div class="my-5 py-5">
      <p class="mb-3">アンケートを通してゆらぎ肌に適した化粧品に変えることが、効果的な対策だと示唆されました。</p>
      <p class="mb-3">実際にゆらぎ肌の対策を行った中で高い、効果を感じたものについて詳しく聞いてみました。</p>
      <p class="mb-3"><strong>■ゆらぎ肌対策で効果が高いと感じたことを具体的に教えてください</strong></p>
      <p class="mb-3">・緑黄色野菜を意識して多く摂ることと、保湿系化粧品を使用する。乳液ではなく、クリームを使用する（20代）<br>・化粧品や化粧水・乳液を無添加のものに変えること（30代）<br>・スキンケアに肌がなれるため定期的にスキンケアを変えることがいい（20代）<br>・保湿効果が高いクリームを塗る（20代）</p>
      <p>季節に応じで、美肌に対するスキンケアやアプローチを変えて対策することは重要と思う人は多いようです。</p>
    </div>

    <div class="feature-row pt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">美容成分の「フラーレン」。どんな効果を期待している？</h3>
        <p class="mb-3">「ゆらぎ肌の対策として美容成分のフラーレンは知っていますか？」と質問したところ、<strong>『はい（7.4％）』</strong>と回答したのは約1割。</p>
        <p class="mb-3">美容成分の1つであるフラーレンを知っている方は少ないようです。</p>
        <p class="mb-3">フラーレンを知っている方に「フラーレンの効果として期待しているものは何ですか？」と質問したところ、</p>
        <p class="mb-3"><strong>『エイジングケア（36.5％）』<br>『抗酸化作用（33.8％）』<br>『保湿（24.3％）』</strong></p>
        <p>フラーレンに対し、<strong>エイジングケアの成分として期待している方</strong>や<strong>抗酸化作用や保湿効果、肌のバリア機能へのサポート</strong>など、美肌を目指す方にとっては気になる成分であることがわかります。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202403_07.jpg">
      </div>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202403_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75 text-center">
        <h3 class="mb-3">ゆらぎ肌の有効な対策は<br>保湿効果のある<br>スキンケア商品がカギ！</h3>
        <p class="mb-3">今回の調査で20代、30代、40代と年齢に関係なく、<br>ゆらぎ肌を感じている方が半数以上いることが明らかに。</p>
        <p class="mb-3">春は気温や湿度、紫外線などが変動する季節の変わり目。<br>そのためお肌のバリア機能が低下しやすくゆるぎ肌に悩みやすいのです。</p>
        <p class="mb-3">気にする方も多い一方で、約7割の方がゆらぎ肌の対策をしておらず、<br>理由として効果的な対策方法がわからない方が多いよう。</p>
        <p class="mb-3">そんな中、ゆらぎ肌の対策している方は<br>「化粧品の追加や変更」「スキンケアの見直し」<br>を行っています。</p>
        <p>多くの方が保湿力に優れたスキンケア商品の使用で<br>高い効果を実感していることから<br>普段のスキンケアに保湿効果のあるアイテムを取り入れたり<br>見直すことが春のゆらぎ肌対策に効果的といえるかもしれません。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">重要なのは、季節に肌にあわせてスキンケア商品の見直しやアイテムを追加すること。</p>
        <p class="mb-3">また、それらのスキンケアを受け入れるために、<br>肌を万全の状態に整えておくこと。</p>
        <p class="mb-3">ゆらぎ肌への対策としてフラーレンの活用を意識してみてはいかがでしょうか？</p>
        <p>スペシャルケアでうるおいに満ちた輝き肌へ！</p>
      </div>
    </div>
   
    <div class="layer_02 pt-5">
      <img src="@/assets/img/column/202403_09.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>理想の美しさを求めるスペシャルケア</span><br>SPECIALシリーズ</h2>
          <p class="mb-3">理想の美しさは、一人ひとり違います。</p>
          <p class="mb-3">ピンとしたハリ肌。透明感にあふれた肌。</p>
          <p class="mb-3">乾燥による小ジワの目立たない肌。</p>
          <p class="mb-3">あるいは、年齢を感じさせない、<br>輝きに満ちた表情かもしれません。</p>
          <p class="mb-3">思い描くその肌、その表情へ導くアイテム。</p>
          <p class="mb-3">ベーシックケアだけでは足りないものを補うアイテム。</p>
          <p>ゆっくりと鏡に向かい、そっと肌にふれて、<br>まずは、特別な一品を選んでみてください。</p>
        </div>
      </div>
    </div>

    <h2 class="mt-5 pt-5 mb-3">ずっと素肌でいたいから。</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">基本の日々のケアに立ち返り、明日も自分の肌を好きでいるために。</p>
      <p>あなたらしい毎日をあなたのペースで取り入れてみてほしい。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_creamf_202403.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">SPECIAL<br>マナビス クリーム F</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">乾燥による小ジワの目立たない*、うるおいと輝きに満ちた肌へ。</p>
        <p class="mb-3">フラーレン配合のエイジングケアクリーム。</p>
        <p>さらに、植物由来保湿成分もたっぷり配合したリッチなクリーム。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p>保湿力が高く、持続するので嬉しい。化粧のりも良くなるし、乾燥を防げていると感じます。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">しっとり濃密で凄く良い。</p>
        <p>これを塗ると、シワも薄くなるような実感を感じています。とても気に入りました。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p>エイジングケア、抗酸化力があると言われるフラーレン成分が入っていて、更にフラーレンロゴマークが表記されてありましたので、安心して使用出来ました。</p>
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">SPECIAL<br>マナビス リフトセラム</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">4種の「ヒアルロン酸」を贅沢に配合。</p>
        <p class="mb-3">更に数種の美容成分も配合し、<br>なじんだ後にピンとした上質なハリを感じます。</p>
        <p>肌にすうっとなじみ、キメを整えるスペシャルな美容液。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_liftserum_202403.jpg">
      </div>
    </div>

    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">ベタつかずトロッとしたテクスチャー。無色透明で爽やかにほんのり香ります。</p>
        <p>皮膚にベールが掛かったような安心感。浸透もよくて気持ちのいい美容液です。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">ヒアルロン酸が4種類も入っていて「贅沢な美容液」というのはその通り。</p>
        <p>肌にスーッと浸透し、しっとりピーンという肌感です。とても使用感がよく、値段通りいい商品だと思います。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">濃厚な感じがあり、肌がとても潤います。</p>
        <p>保湿クリームを使わなくても、長い時間保湿が維持されているので、<br>ナイトケアをした翌日の朝は、もっちりぷにぷになお肌のまま！</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">その他SPECIALラインの商品</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_whiteningessence_202403.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用ホワイトニングエッセンスEX</div>
          <p>なめらかで透明感のある肌へ。<br>しっとりとなじむ美白美容液。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_bihakulotion_202403.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用美白ローション</div>
          <p>紫外線やブルーライトによる乾燥から守り、<br>肌あれを防ぐ、集中ケア化粧水。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_moisturegel_202403.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">モイスチャージェル</div>
          <p>乾燥による小ジワの目立たない肌へ。<br>バリア機能を助けるジェル状保湿液。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000006.000124389.html" target="_blank" title="【ゆらぎ肌を感じる時期は3月と4月】半数以上がゆらぎ肌に悩んでいる一方で7割の方が対策できていないという結果に！実際に効果が高いと感じた対策方法とは？">【ゆらぎ肌を感じる時期は3月と4月】半数以上がゆらぎ肌に悩んでいる一方で7割の方が対策できていないという結果に！実際に効果が高いと感じた対策方法とは？</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「春のゆらぎ肌」に関する調査<br>
        【調査期間】2024年2月15日（木）～2024年2月16日（金）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「PRIZMA」によるインターネット調査<br>
        【調査人数】1,005人<br>
        【調査対象】調査回答時に20～40代女性と回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: baseline;
      background-image: url('../../assets/img/column/202403_09.jpg');
      background-size: cover;
      min-height: 750px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
      justify-content: end;
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 40%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
   .img-top-slide_text {
      width: 100%;
    }
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>